import axios from "axios";
import { Branch_Gst_Verification_URL, Master_Service_TEAMS_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}
export const sidebarTeamDetails = {
  GET_SIDEBAR_TEAMS_DETAILS_SUCCESS: "GET_SIDEBAR_TEAMS_DETAILS_SUCCESS",
  GET_SIDEBAR_TEAMS_DETAILS_ERROR: "GET_SIDEBAR_TEAMS_DETAILS_ERROR",
};

export function getTeamSideBarDetails(props) {
  const { accessToken, partnerFirmID } = props;

  return (dispatch) =>
    axios({
      method: "post",
      url: `${Master_Service_TEAMS_URL}/getAllTeamDetailsByPartnerFirmId?partnerFirmId=${partnerFirmID}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getTeamSideBarDetailSuccess(response.data));
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getTeamSideBarDetailError(error));
          dispatch(clearLogoutData());

          throw error;
        }
      })
      .catch((err) => {
        dispatch(getTeamSideBarDetailError(err));
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));
          dispatch(clearLogoutData());
          return err;
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function getTeamSideBarDetailError(error) {
  return {
    type: sidebarTeamDetails.GET_SIDEBAR_TEAMS_DETAILS_ERROR,
    payload: error,
  };
}

export function getTeamSideBarDetailSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: sidebarTeamDetails.GET_SIDEBAR_TEAMS_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export const sideBarBranchActions = {
  SIDE_BAR_BRANCH_SUCCESS: "SIDE_BAR_BRANCH_SUCCESS",
  SIDE_BAR_BRANCH_ERROR: "SIDE_BAR_BRANCH_ERROR",
};

export function getSideBarBranch(props) {
  const { accessToken, partnerFirmId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      url: `${Branch_Gst_Verification_URL}/getAllBranchDetailsByPartnerFirmId?partnerFirmId=${partnerFirmId}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(SideBarBranchSuccess(response.data));
          // dispatch(setLogoutFlag());
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(SideBarBranchError(error));

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        dispatch(SideBarBranchError(err));

        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        }
      });
}

export function SideBarBranchError(error) {
  return {
    type: sideBarBranchActions.SIDE_BAR_BRANCH_ERROR,
    payload: error,
  };
}

export function SideBarBranchSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: sideBarBranchActions.SIDE_BAR_BRANCH_SUCCESS,
      payload: props,
    });
  };
}
